import { money } from './logic';
import { CommandDeparture } from './types';

export function priceLevel(level: number | null | undefined): string {
  if (level == null || !Number.isFinite(level)) return '—';
  if (level === 0) return 'base price';
  const percent = Math.abs(level * 100).toLocaleString('en-AU', { maximumFractionDigits: 1 });
  return level > 0 ? `+${percent}% surcharge` : `-${percent}% discount`;
}

export function averageSellPrice(d: CommandDeparture) {
  const packages = d.packages?.filter((p) => p.type !== 'cancellation');
  const average = (ttv: number, pax: number) => (pax > 0 ? ttv / pax : null);
  const base = packages?.filter((p) => p.type === 'base') ?? [];
  const ltle = packages?.filter((p) => p.type !== 'base') ?? [];
  const totals = (rows: typeof base) => ({
    ttv: rows.reduce((sum, p) => sum + p.ttv, 0),
    pax: rows.reduce((sum, p) => sum + p.pax, 0),
  });
  const b = totals(base),
    l = totals(ltle);
  return {
    all: packages?.length ? average(b.ttv + l.ttv, b.pax + l.pax) : average(d.ttv, d.pax),
    base: packages?.length ? average(b.ttv, b.pax) : average(d.ttv - (d.ltle_ttv ?? 0), d.pax - (d.bundle_pax ?? 0)),
    ltle: packages?.length ? average(l.ttv, l.pax) : average(d.ltle_ttv ?? 0, d.ltle_margin_pax ?? 0),
  };
}

export function currentPrice(d: CommandDeparture): string {
  if (!(d.on_sale ?? d.state === 'On sale') || d.list_price_now_aud === undefined) return '—';
  if (d.list_price_now_aud == null) return d.on_sale_via ? 'Sold via LTLE' : '—';
  const level = priceLevel(d.price_level_now);
  return `${money(d.list_price_now_aud)}${level === '—' ? '' : ` · ${level}`}`;
}

export function averagePriceTooltip(d: CommandDeparture): string {
  const prices = averageSellPrice(d);
  return `Tour only ${money(prices.base)} / traveller · LTLE ${money(prices.ltle)} / traveller · Avg level when booked: ${priceLevel(d.price_level_sold)}`;
}
